export default __webpack_public_path__ + "static/media/ei2.dc8f5d9e.jpg";